import { render, staticRenderFns } from "./GoalsDeadlinesCard.vue?vue&type=template&id=112f413e&scoped=true"
import script from "./GoalsDeadlinesCard.vue?vue&type=script&lang=js"
export * from "./GoalsDeadlinesCard.vue?vue&type=script&lang=js"
import style0 from "./GoalsDeadlinesCard.vue?vue&type=style&index=0&id=112f413e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f413e",
  null
  
)

export default component.exports